import React, { useEffect, useState } from "react";
import { nav } from "../mock/inferraData";
import { EDGE } from "./primitives";

function Mark() {
  return (
    <svg width="26" height="26" viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <rect x="1.5" y="1.5" width="25" height="25" rx="3" stroke="#14201b" strokeWidth="2" />
      <rect x="8" y="8" width="12" height="12" rx="1.5" stroke="#0f5c4b" strokeWidth="2" />
      <circle cx="14" cy="14" r="2" fill="#0f5c4b" />
    </svg>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        height: 74,
        display: "flex",
        alignItems: "center",
        paddingLeft: EDGE,
        paddingRight: EDGE,
        background: scrolled ? "rgba(244,229,207,0.82)" : "transparent",
        borderBottom: scrolled ? "1px solid var(--line)" : "1px solid transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        transition: "background .35s ease, border-color .35s ease, backdrop-filter .35s ease",
      }}
    >
      <div
        style={{
          maxWidth: 1440,
          margin: "0 auto",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <a href="#top" style={{ display: "flex", alignItems: "center", gap: 11 }}>
          <Mark />
          <span
            className="font-type"
            style={{ fontSize: 24, fontWeight: 700, letterSpacing: "-0.5px" }}
          >
            {nav.brand}
          </span>
        </a>

        <nav className="nav-desktop" style={{ display: "flex", alignItems: "center", gap: 38 }}>
          {nav.links.map((l) => (
            <a key={l.label} href={l.href} className="navlink" style={{ fontSize: 14.5 }}>
              {l.label}
            </a>
          ))}
          <a
            href={nav.cta.href}
            className="btn btn--solid"
            style={{ height: 42, padding: "0 18px", fontSize: 14, borderRadius: 8 }}
          >
            {nav.cta.label}
          </a>
        </nav>

        <button
          className="nav-burger"
          aria-label="Menu"
          onClick={() => setOpen((o) => !o)}
          style={{
            display: "none",
            flexDirection: "column",
            gap: 5,
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 6,
          }}
        >
          <span style={{ width: 24, height: 2, background: "var(--ink)" }} />
          <span style={{ width: 24, height: 2, background: "var(--ink)" }} />
          <span style={{ width: 24, height: 2, background: "var(--ink)" }} />
        </button>
      </div>

      {open && (
        <div
          className="nav-mobile-panel"
          style={{
            position: "absolute",
            top: 74,
            left: 0,
            right: 0,
            background: "rgba(244,229,207,0.98)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid var(--line)",
            padding: "18px " + "clamp(20px,6vw,120px)",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          {nav.links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              style={{ fontSize: 16, color: "var(--ink)" }}
            >
              {l.label}
            </a>
          ))}
          <a
            href={nav.cta.href}
            onClick={() => setOpen(false)}
            className="btn btn--solid"
            style={{ height: 46, fontSize: 15, borderRadius: 8, marginTop: 4 }}
          >
            {nav.cta.label}
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 860px) {
          .nav-desktop { display: none !important; }
          .nav-burger { display: flex !important; }
        }
      `}</style>
    </header>
  );
}
